import React from 'react'
import { Flex, Box } from 'reflexbox'
import { useHistory } from 'react-router-dom'

import Card from 'components/Card'
import { Title, SemiTitle } from 'components/Typography'
import Button from 'components/Button'

import { useUser } from 'context/user-context'

const Settings = () => {
  const { user } = useUser()
  const history = useHistory()

  return (
    <Flex flexDirection='column'>
      <Title as='h3'>Configurações</Title>
      <Card mt='24px'>
        <Box mb='24px'>
          <SemiTitle color='grays.N500'>E-mail</SemiTitle>
          <p>{user?.email}</p>
        </Box>
        <Button size='big' onClick={() => history.push('/staff/settings/edit-password')}>
          Alterar senha
        </Button>
      </Card>
    </Flex>
  )
}

export default Settings
